import {
  withTranslation,
} from 'react-i18next';

import AdminRegattaPaymentsPageView from './AdminRegattaPaymentsPageView';

const TranslatedComponent = withTranslation()(AdminRegattaPaymentsPageView);

const Component = TranslatedComponent;

export default Component;
